import connectToDoc from './connectToDoc';
export default function connectToNote() {
  var mapPropsToNoteId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (_ref) {
    var noteId = _ref.noteId;
    return {
      noteId: noteId
    };
  };
  return connectToDoc(function (props) {
    return {
      id: mapPropsToNoteId(props).noteId,
      collection: 'notes',
      type: 'rich-text'
    };
  });
}